import PubSub from "underpub-js";

var CardThree = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-CardThree',
	};

	$.extend(true, this.options, options);

};

CardThree.prototype.init = function() {

	var self = this;

};

export default CardThree;
